( () => {
	const accordionItems = document.querySelectorAll< HTMLDivElement >(
		'footer .accordion .accordion__toggle'
	);
	accordionItems.forEach( ( accordionItem ) => {
		accordionItem.addEventListener( 'click', ( event ) => {
			if ( event.target instanceof HTMLElement ) {
				// Toggle class on clicked element.
				const toggleItem = event.target.closest( '.accordion__item' );
				toggleItem?.classList.toggle( 'is-open' );

				// Toggle class on containing list.
				const toggleList = event.target
					.closest( '.container' )
					?.querySelector( '.accordion__collapse' );
				toggleList?.classList.toggle( 'is-open' );
			}
		} );
	} );
} )();
